/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Propulsion type
 */
export type PropulsionTypeEnum = 'human' | 'electric_assist' | 'electric' | 'combustion' | 'combustion_diesel' | 'hybrid' | 'plug_in_hybrid' | 'hydrogen_fuel_cell';

export const PropulsionTypeEnum = {
    Human: 'human' as PropulsionTypeEnum,
    ElectricAssist: 'electric_assist' as PropulsionTypeEnum,
    Electric: 'electric' as PropulsionTypeEnum,
    Combustion: 'combustion' as PropulsionTypeEnum,
    CombustionDiesel: 'combustion_diesel' as PropulsionTypeEnum,
    Hybrid: 'hybrid' as PropulsionTypeEnum,
    PlugInHybrid: 'plug_in_hybrid' as PropulsionTypeEnum,
    HydrogenFuelCell: 'hydrogen_fuel_cell' as PropulsionTypeEnum
};